import clsx from "clsx";
import useSearchWords from "hooks/useSearchWords";
import useQuery from "hooks/useQuery";

export interface JobPropsHook {
  searchWords?: string[];
  classNames: {
    title: string;
    id: string;
  };
}

export default function useJobProps(archived: string): JobPropsHook {
  const [query] = useQuery("jobs");

  const searchWords = useSearchWords(query);

  const classNames = {
    title: clsx("text-14-22-em", archived === "yes" && "text-red-200"),
    id: clsx("text-12-18-em", archived === "yes" && "text-red-200"),
  };

  return {
    searchWords,
    classNames,
  };
}
